"use strict";
/**
 * @file Created on 08.06.2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../../core/model/data-dictionary/StructPropBuilder");

var NotificationDoc_1 = require("../NotificationDoc");

var NSimDummyProduct_1 = require("./NSimDummyProduct");
/**
 * @author Tomas Leity
 */


var NSimDummyCreatedDTO =
/*#__PURE__*/
function (_NotificationDoc_1$No) {
  _inherits(NSimDummyCreatedDTO, _NotificationDoc_1$No);

  /**
   * @param products
   */
  function NSimDummyCreatedDTO(products) {
    var _this;

    _classCallCheck(this, NSimDummyCreatedDTO);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(NSimDummyCreatedDTO).call(this));
    _this.products = products;
    return _this;
  }
  /**
   * Converter from data-dictionary representation
   */


  _createClass(NSimDummyCreatedDTO, null, [{
    key: "fromDataDict",
    value: function fromDataDict(mat) {
      return new NSimDummyCreatedDTO(mat.products);
    }
  }]);

  return NSimDummyCreatedDTO;
}(NotificationDoc_1.NotificationDoc);

exports.NSimDummyCreatedDTO = NSimDummyCreatedDTO;

NSimDummyCreatedDTO.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(NSimDummyCreatedDTO.name);
  return {
    products: builder.listOf(builder.obj('products', NSimDummyProduct_1.NSimDummyProduct.schema, function (mat) {
      return NSimDummyProduct_1.NSimDummyProduct.fromDataDict(mat);
    }))
  };
}();